"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapSearchPreviewShades = exports.mapSearchPreviewQuery = exports.mapLinksToSearchQueries = exports.getPrice = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _productBox = require("@ori/product-box");
var _tsUtils = require("@ori/ts-utils");
var _constants = require("../constants");
var _getSearchUrl = require("./getSearchUrl");
var _mapEnableQuickBuyButton = require("./mapEnableQuickBuyButton");
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing -- it can come as empty string */

const mapLinksToSearchQueries = links => links?.map(link => ({
  text: link?.title ?? '',
  url: link?.relativeUrl ?? ''
})).filter(query => query.text && query.url) ?? [];
exports.mapLinksToSearchQueries = mapLinksToSearchQueries;
const mapShadeWithPrice = shade => {
  const {
    productCode,
    hexColors,
    imageUrl
  } = (0, _productBox.mapShade)({
    ...shade,
    productCode: shade.productCode
  });
  return {
    name: shade.shadeName,
    productCode,
    hexColors,
    imageUrl,
    canBeSold: (0, _productBox.mapCanBeSold)(shade.labels),
    price: {
      currentFormatted: (0, _productBox.getCurrentFormattedPrice)({
        formattedPrice: shade.formattedPrice
      }),
      oldFormatted: (0, _productBox.getOldPrice)({
        formattedPrice: shade.formattedPrice
      })
    }
  };
};
const mapSearchPreviewShades = shades => shades?.filter(_tsUtils.isNonNullable).map(mapShadeWithPrice) || [];
exports.mapSearchPreviewShades = mapSearchPreviewShades;
const getPrice = ({
  priceAfterImmediateDiscount,
  currentPrice
}) => Number.parseFloat((priceAfterImmediateDiscount ?? currentPrice ?? 0).toString());
exports.getPrice = getPrice;
const mapSearchPreviewQuery = ({
  query,
  personalSubscriptionsEnabled
}) => {
  const {
    totalProductsCount,
    products,
    suggestions,
    relatedBrandLinks,
    relatedCategoryLinks
  } = query.application?.productSearchPreview?.searchResults ?? {};
  return {
    numberOfProducts: totalProductsCount ?? 0,
    products: products?.filter(_tsUtils.isNonNullable).map(product => {
      const shades = mapSearchPreviewShades(product.concept?.products);
      const labels = (0, _productBox.mapLabels)(product.concept?.labels, {
        deal: [_presentationComponents.OFFER]
      });
      return {
        isMultishade: shades.length > 1,
        canBeSold: (0, _mapEnableQuickBuyButton.mapEnableQuickBuyButton)(product.labels, shades),
        url: product.pdpUrl?.relativeUrl,
        code: product.productCode,
        name: product.concept?.name ?? '',
        brand: product.concept?.brand?.name,
        image: product.imageUrl,
        labels,
        category: product.concept?.categories?.[0]?.name,
        hasAutosubscribe: (0, _productBox.mapHasAutoSubscription)(product.labels) || personalSubscriptionsEnabled && !!product.subscription?.available,
        price: {
          currentFormatted: (0, _productBox.getCurrentFormattedPrice)({
            formattedPrice: product.formattedPrice
          }),
          oldFormatted: (0, _productBox.getOldPrice)({
            formattedPrice: product.formattedPrice
          }),
          price: getPrice({
            priceAfterImmediateDiscount: product.price?.price?.priceAfterImmediateDiscount,
            currentPrice: product.price?.price?.currentPrice
          })
        },
        shades
      };
    }) ?? [],
    suggestions: [...(suggestions ?? [])].filter(_tsUtils.isNonNullable).map(text => ({
      text,
      url: (0, _getSearchUrl.getSearchUrl)(text)
    })).slice(0, _constants.SEARCH_PREVIEW_SUGGESTIONS_LIMIT),
    brands: mapLinksToSearchQueries(relatedBrandLinks).slice(0, _constants.SEARCH_PREVIEW_BRANDS_LIMIT),
    categories: mapLinksToSearchQueries(relatedCategoryLinks).slice(0, _constants.SEARCH_PREVIEW_CATEGORIES_LIMIT)
  };
};
exports.mapSearchPreviewQuery = mapSearchPreviewQuery;
